import { createContext, useState } from 'react';

export const TransferSubkonProduksiContext = createContext();

export const TransferSubkonProduksiProvider = ({ children }) => {
  const [dataJobOrder, setJobOrder] = useState({});

  const [dataPermintaan, setDataPermintaan] = useState({
    sf: [],
  });

  const [dataTransfer, setDataTransfer] = useState({
    sf: [],
  });

  const [dataHistory, setDataHistory] = useState({
    sf: [],
  });

  const [modalForm, setModalForm] = useState({
    tab: 'sf',
    action: 'create',
    data: null,
    showRegistrasi: false,
    showKontrak: false,
  });

  const [modalKonfirmasi, setModalKonfirmasi] = useState(false);

  return (
    <TransferSubkonProduksiContext.Provider
      value={{
        dataJobOrder,
        setJobOrder,
        dataPermintaan,
        setDataPermintaan,
        dataTransfer,
        setDataTransfer,
        dataHistory,
        setDataHistory,
        modalForm,
        setModalForm,
        modalKonfirmasi,
        setModalKonfirmasi,
      }}
    >
      {children}
    </TransferSubkonProduksiContext.Provider>
  );
};

export const withTransferSubkonProduksiProvider = (Component) => (props) => {
  return (
    <TransferSubkonProduksiProvider>
      <Component {...props} />
    </TransferSubkonProduksiProvider>
  );
};
